import React, { useState } from 'react';

import {
  CNavTitle,
  CSidebar,
  CSidebarBrand,
  CSidebarHeader,
  CSidebarNav,
} from '@coreui/react';
import CIcon from '@coreui/icons-react';

// sidebar nav config
import { cilInfo, cilLockLocked, cilUser } from '@coreui/icons';
import { useMediaQuery } from 'react-responsive';

import VNNICLOGO from './vnnic-logo.png';

import './AppSidebar.scss';

const AppSidebar = ({ setContent }) => {
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(true);
  const isMobile = useMediaQuery({ query: '(max-width: 767px)' });

  // eslint-disable-next-line
  const toggleSidebar = () => {
    setIsSidebarCollapsed(!isSidebarCollapsed);
  };

  const MobileMenu = () => {
    return (
      <div className="mobile-menu">
        <div className="mobile-menu--container">
          <span onClick={() => setContent(0)}>
            <CIcon customClassName="nav-icon" icon={cilUser} />
          </span>
          <span onClick={() => setContent(1)}>
            <CIcon customClassName="nav-icon" icon={cilInfo} />
          </span>
          <span onClick={() => setContent(2)}>
            <CIcon customClassName="nav-icon" icon={cilLockLocked} />
          </span>
          {/* <span onClick={() => setContent(3)}>
            <CIcon customClassName="nav-icon" icon={cilCloudDownload} />
          </span> */}
        </div>
      </div>
    );
  };

  return (
    <>
      {isMobile && <MobileMenu />}
      <CSidebar
        className={`${isMobile ? 'mobile-sidebar' : ''} border-end ${
          isSidebarCollapsed ? 'collapsed' : ''
        }`}
      >
        <CSidebarHeader className="border-bottom">
          <CSidebarBrand style={{ padding: '10px' }}>
            <img
              src={VNNICLOGO}
              alt="vnnic-logo"
              style={{
                width: '120px',
              }}
            />
          </CSidebarBrand>
        </CSidebarHeader>
        <CSidebarNav>
          <CNavTitle style={{ fontSize: '14px' }}>Admin</CNavTitle>
          <div className="menu-container">
            <div className="menu-item" onClick={() => setContent(1)}>
              <span style={{ fontSize: '13px' }}>
                <CIcon customClassName="nav-icon" icon={cilInfo} />
                Import Data
              </span>
            </div>

            <div className="menu-item" onClick={() => setContent(2)}>
              <span style={{ fontSize: '13px' }}>
                <CIcon customClassName="nav-icon" icon={cilLockLocked} />
                Password
              </span>
            </div>

            <div className="menu-item" onClick={() => setContent(0)}>
              <span style={{ fontSize: '13px' }}>
                <CIcon customClassName="nav-icon" icon={cilUser} />
                System User
              </span>
            </div>

            {/* <div className="menu-item" onClick={() => setContent(3)}>
              <span style={{ fontSize: '13px' }} hidden>
                Backup Data
              </span>
            </div> */}
          </div>
        </CSidebarNav>
        <CSidebarHeader
          className="border-top"
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <h2
            style={{
              fontSize: '12px',
              opacity: '0.5',
              textAlign: 'center',
              margin: 0,
              fontWeight: '400',
            }}
          >
            Developed by VIZION
          </h2>
          {/* <CSidebarToggler onClick={toggleSidebar} /> */}
        </CSidebarHeader>
      </CSidebar>
    </>
  );
};

export default React.memo(AppSidebar);
